import React, { useCallback } from "react";
import { AHText, Box, Circle } from "arkh";
import { RoutineOccasionStatus } from "./__generated__/TeamScheduleSectionHeaderStatusDot_routineOccasion.graphql";

export function StatusCompact(props: {
  occasions: readonly {
    readonly status: RoutineOccasionStatus;
  }[];
}) {
  const summary = new Map();
  props.occasions.forEach((occasion) => {
    if (!occasion || !occasion.status) {
      return;
    }
    summary.set(occasion.status, (summary.get(occasion.status) ?? 0) + 1);
  });
  const summaryList = (
    [
      ["NOT_COMPLETED", "IN_PROGRESS_EXPIRED"],
      ["COMPLETED", "REQUIRED_COMPLETED"],
      ["IN_PROGRESS"],
      ["FUTURE"],
      ["NO_TASKS_COMPLETED"],
    ] as RoutineOccasionStatus[][]
  ).flatMap((status) => {
    const count = status.reduce((acc, cur) => acc + (summary.get(cur) ?? 0), 0);
    if (!count) {
      return [];
    }
    return [{ status: status[0], count }];
  });

  const renderStatusCircle = useCallback((status: RoutineOccasionStatus) => {
    switch (status) {
      case "FUTURE":
        return <Circle size="dot" borderColor="neutral" borderWidth={1} />;
      case "REQUIRED_COMPLETED":
      case "COMPLETED":
        return <Circle size="dot" color="positive" />;
      case "NOT_COMPLETED":
        return <Circle size="dot" color="negative" />;
      case "IN_PROGRESS":
        return <Circle size="dot" borderColor="primary" borderWidth={1} />;
      case "IN_PROGRESS_EXPIRED":
        return <Circle size="dot" color="negative" />;
      case "NO_TASKS_COMPLETED":
        return <Circle size="dot" color="border-primary" />;
      default:
        return <Circle size="dot" color="surface" />;
    }
  }, []);

  return (
    <Box
      style={{
        flexDirection: "row",
        flex: 1,
        justifyContent: "flex-end",
      }}
    >
      {summaryList.map(({ status, count }) => (
        <Box
          key={status}
          spaceLeft="xsmall"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          {renderStatusCircle(status)}
          <AHText spaceLeft="xsmall" type="subtitle">
            {count}
          </AHText>
        </Box>
      ))}
    </Box>
  );
}
